import { PrimarySolidButton } from "../UI/PrimarySolidButton";

export function TestScreen() {
  return (
    <PrimarySolidButton
      label={"Trigger error"}
      onClick={() => {
        throw new Error("Test error");
      }}
    />
  );
}
